export class User {
  gRecaptchaResponse: string;
  customerName: string;
  customerNumber?: string;
  email: string;
  firstName: string;
  language: string;
  lastName: string;
  password?: string;
  phoneNumber?: string;
  privacy: boolean = false;
  confirmPassword?: string;
  salutation: string;
  subsribeToNewsletter?: boolean = true;
  type: string;
}

